import { CurrentPointOnboardingType, OnboardingState } from './types';

export const SELECT_PLAYER_FLOW_DEFAULT_PLAYER = 'WEB';

export const DEFAULT_CURRENT_POINT_ONBOARDING: CurrentPointOnboardingType = {
  id: undefined,
  address: undefined,
  stream: undefined,
  device: undefined,
  isEnabled: undefined,
};

export const DEFAULT_ONBOARDING_STATE: OnboardingState = {
  inFlow: false,
  flowType: undefined,
  isTemplateMode: false,
  currentPoint: DEFAULT_CURRENT_POINT_ONBOARDING,
};
